import { render, staticRenderFns } from "./SupplierSelector.vue?vue&type=template&id=638a3e41&"
import script from "./SupplierSelector.vue?vue&type=script&lang=js&"
export * from "./SupplierSelector.vue?vue&type=script&lang=js&"
import style0 from "./SupplierSelector.vue?vue&type=style&index=0&id=638a3e41&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports